function loadMore() {
  init();
}
function init() {
  var $loadMore = jQuery('.load-more-wrap-link');
  var $sectionBlogList = jQuery('.section-blog-list');
  $loadMore.on('click', function () {
    var $offset = jQuery('.section-blog').attr('attr-offset');
    jQuery.getJSON("".concat(location.protocol, "//").concat(document.domain, "/wp-json/comea/v2/all-posts?offsetPost=").concat($offset), function (json) {
      var obj = jQuery.parseJSON(json);
      for (var i in obj) {
        templateItem(obj[i], $sectionBlogList);
      }
    });
    $loadMore.hide(500);
  });
}
function templateItem(obj_item, $sectionBlogList) {
  var html_item = "".concat('<div class="col">' + '<div class="blog-post">' + '<div class="blog-post__image">' + '<img src="').concat(obj_item.img, "\" alt=\"post img\">") + '</div>' + '<div class="blog-post__body">' + "<div class=\"blog-post__text\"><strong>".concat(obj_item.content, "</strong></div>") + '<div class="btn-wrap">' + "<a href=\"".concat(obj_item.link, "\" class=\"btn btn__secondary\">").concat(obj_item.title, "</a>") + '</div>' + '</div>' + '</div>' + '</div>';
  $sectionBlogList.append(html_item);
}
export default loadMore;